import React from 'react';

import ChartInsight from '../../components/ChartInsight';

export const CampaignPerformanceDetail = ({data}) => (
    <div>
        <ChartInsight {...data} />
    </div>
);

export default CampaignPerformanceDetail;


// WEBPACK FOOTER //
// ./src/pages/details/CampaignPerformanceDetail.js